"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _styles = require("./styles");

var _class, _temp;

var SelectedItems = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SelectedItems, _React$Component);

  function SelectedItems() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectedItems);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectedItems)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onRemove", function (label, itemId, genre) {
      var onChangeHandler = _this.props.onChangeHandler;
      onChangeHandler({
        itemId: itemId,
        label: label,
        genre: genre
      }, true);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderOptions", function (selectedOptions, theme) {
      return selectedOptions.map(function (option) {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)(_styles.optionStyleDesktop)
        }, _react.default.createElement("span", {
          className: (0, _classnames.default)((0, _styles.labelStyleDesktop)(theme))
        }, option.label), _react.default.createElement("div", {
          className: (0, _classnames.default)((0, _styles.iconStyleDesktop)(theme)),
          onClick: function onClick() {
            return _this.onRemove(option.label, option.itemId, option.genre);
          },
          role: "presentation"
        }, _react.default.createElement(_Icon.default, {
          type: "close"
        })));
      });
    });
    return _this;
  }

  (0, _createClass2.default)(SelectedItems, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectedOptions = _this$props.selectedOptions,
          theme = _this$props.theme;

      if (!selectedOptions.length) {
        return null;
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_styles.rootStyleDesktop)
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _styles.titleStyleDesktop)(theme))
      }, " Applied filters "), this.renderOptions(selectedOptions, theme));
    }
  }]);
  return SelectedItems;
}(_react.default.Component), _temp)) || _class;

var _default = SelectedItems;
exports.default = _default;